var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 16 21",
        fill: "currentColor",
        stroke: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M10 0.976562H2C0.9 0.976562 0 1.87656 0 2.97656V18.9766C0 20.0766 0.9 20.9766 2 20.9766H14C15.1 20.9766 16 20.0766 16 18.9766V6.97656L10 0.976562ZM14 18.9766H2V2.97656H10V6.97656H14V18.9766ZM8 15.9766C6.9 15.9766 6 15.0766 6 13.9766V8.47656C6 8.19656 6.22 7.97656 6.5 7.97656C6.78 7.97656 7 8.19656 7 8.47656V13.9766H9V8.47656C9 7.09656 7.88 5.97656 6.5 5.97656C5.12 5.97656 4 7.09656 4 8.47656V13.9766C4 16.1866 5.79 17.9766 8 17.9766C10.21 17.9766 12 16.1866 12 13.9766V9.97656H10V13.9766C10 15.0766 9.1 15.9766 8 15.9766Z",
          "stroke-width": "0",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }